export default class GptAiExcludeRules {
  static PAYMENT_SYSTEM = "EXCLUDE_RULE_PAYMENT_SYSTEM";

  static PAYROLL_SYSTEM = "EXCLUDE_RULE_PAYROLL_SYSTEM";

  static ATM_WITHDRAWAL = "EXCLUDE_RULE_ATM_WITHDRAWAL";

  static EXPENSE_REIMBURSEMENT = "EXCLUDE_RULE_EXPENSE_REIMBURSEMENT";

  static MARKETPLACE = "EXCLUDE_RULE_MARKETPLACE";

  static TRANSFER = "EXCLUDE_RULE_TRANSFER";

  static CHECK = "EXCLUDE_RULE_CHECK";

  static PERSON_TO_PERSON_PAYMENT = "EXCLUDE_RULE_P2P_PAYMENT";

  static UNCLEAR = "EXCLUDE_RULE_UNCLEAR";

  static CUSTOM = "EXCLUDE_RULE_CUSTOM";
}
